import React, { useRef, useEffect } from 'react';
import { X } from 'lucide-react';

interface ColorPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  color: string;
  onChange: (color: string) => void;
}

export const ColorPickerModal: React.FC<ColorPickerModalProps> = ({
  isOpen,
  onClose,
  color,
  onChange,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div ref={modalRef} className="bg-white rounded-lg p-6 relative">
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 p-1.5 bg-white text-gray-500 hover:text-gray-700 rounded-full shadow-lg"
        >
          <X className="h-5 w-5" />
        </button>
        <p className="text-sm text-gray-600 mb-4">Click to pick a custom color</p>
        <input
          type="color"
          value={color}
          onChange={(e) => onChange(e.target.value)}
          className="w-64 h-48 cursor-pointer"
        />
      </div>
    </div>
  );
};